/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SongDto interface.
 */
export function instanceOfSongDto(value) {
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('artist' in value) || value['artist'] === undefined)
        return false;
    return true;
}
export function SongDtoFromJSON(json) {
    return SongDtoFromJSONTyped(json, false);
}
export function SongDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'],
        'artist': json['artist'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
export function SongDtoToJSON(json) {
    return SongDtoToJSONTyped(json, false);
}
export function SongDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'artist': value['artist'],
        'comment': value['comment'],
    };
}
